import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import PinGate from './components/PinGate'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root bulunamadı')

createRoot(container).render(
  <StrictMode>
    <PinGate>
      <App />
    </PinGate>
  </StrictMode>,
)

// Service worker YALNIZ üretim yapısında. Geliştirmede modüller `/src`ten
// geliyor, `/assets` diye bir yol yok — kaydetmek hiçbir işe yaramaz, üstelik
// "değişikliğim neden görünmüyor" sorusunu doğurur.
//
// `load` olayından sonra: kayıt ilk boyamayla ağ için yarışmasın.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Kayıt başarısızsa uygulama normal çalışmaya devam eder; tek kayıp
      // varlık önbelleği ve (ileride) bildirim zemini.
      console.warn('Service worker kaydedilemedi', err)
    })
  })
}
